/** @format */

export const CONSTANTS_EMPLOYEE_WEB_EXP = {
  ENV_VAR: "employeeWebExpEnvironment"
};
